<script setup lang="ts">
import type { SourceReference } from '@/types/calculator'

defineProps<{
  assumptions: SourceReference[]
}>()
</script>

<template>
  <section class="assumptions" aria-labelledby="assumptions-title">
    <h2 id="assumptions-title" class="assumptions__title">Sources, assumptions and data date</h2>
    <ul class="assumptions__list">
      <li v-for="source in assumptions" :key="source.name" class="assumptions__item">
        <p class="assumptions__name">
          <a v-if="source.url" :href="source.url" target="_blank" rel="noopener noreferrer">{{
            source.name
          }}</a>
          <template v-else>{{ source.name }}</template>
        </p>
        <p class="assumptions__meta">
          Effective {{ source.effectiveFrom
          }}{{ source.effectiveTo ? ` to ${source.effectiveTo}` : '' }}
          <span v-if="source.version"> &middot; version {{ source.version }}</span>
          <span v-if="source.reviewedAt"> &middot; reviewed {{ source.reviewedAt }}</span>
        </p>
        <p v-if="source.notes" class="assumptions__notes">{{ source.notes }}</p>
      </li>
    </ul>
  </section>
</template>

<style scoped>
.assumptions {
  margin-top: var(--space-8);
}

.assumptions__title {
  font-size: var(--text-xl);
  font-weight: var(--font-semibold);
  margin-bottom: var(--space-4);
}

.assumptions__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: var(--space-4);
}

.assumptions__item {
  padding: var(--space-4);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background-color: var(--color-surface);
}

.assumptions__name {
  font-weight: var(--font-medium);
  margin: 0;
}

.assumptions__meta,
.assumptions__notes {
  margin: var(--space-1) 0 0;
  font-size: var(--text-sm);
  color: var(--color-text-muted);
}
</style>
